import {debounce as _debounce, get as _get} from 'lodash';
import {withRouter} from 'react-router-dom';

import DefaultForm from '@appComponents/DefaultForm';
import {getLink} from '@appComponents/Link';
import {renderPageTitle} from '@utils/helpers';
import {GetStadiumsForSpiideoVenueMapping} from '@graphql/spiideoStadiumMapping/query';
import {getSpiideoVenueLabel} from '@modules/spiideoMappings/utils/helpers';

export class SpiideoVenueMappingForm extends DefaultForm {
    componentDidMount() {
        const link = this.createLinkToIndexPage();
        const navigateToIndex = () => this.props.history.push(link);

        this.setCreateSuccessCallback(navigateToIndex);
        this.setDeleteSuccessCallback(navigateToIndex);
        this.setUpdateSuccessCallback(navigateToIndex);

        this.setField('stadium', {
            onSearchChangeSelect: _debounce(this.getStadiums, 1000),
        });
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        const stadium = _get(this.props, 'GraphQLEntityData.spiideoStadiumMapping.stadium', null);

        if (stadium && stadium !== _get(prevProps, 'GraphQLEntityData.spiideoStadiumMapping.stadium', null)) {
            this.setField('stadium', {
                options: [{
                    key: stadium.id,
                    value: stadium.id,
                    text: getSpiideoVenueLabel(stadium),
                }],
            });
        }

        if (this.props.formParams?.setPageTitle) {
            this.updateTitles(stadium);
        }
    }

    updateTitles = (stadium) => {
        const {id, setPageTitle} = this.props.formParams;
        const label = getSpiideoVenueLabel(stadium);

        setPageTitle(
            renderPageTitle({
                id: id,
                name: label,
                entity: id ? 'venue' : 'venue mapping',
            })
        );
    };

    getStadiums = (event, data) => {
        if (3 > data.searchQuery.length) {
            return;
        }

        this.setField('stadium', {
            loading: true,
            disabled: true,
        });

        const currentStadiumId = _get(this.props, 'GraphQLEntityData.spiideoStadiumMapping.stadium.id', null);

        this.runApolloRequest('query', {
            query: GetStadiumsForSpiideoVenueMapping,
            fetchPolicy: 'network-only',
            variables: {
                search: data.searchQuery || '',
                includeSpiideoStadium: currentStadiumId,
            },
        }, {
            loadingFormFlag: false,
        }).then((response) => {
            const stadiums = _get(response, 'data.stadiumsForSpiideoMappingDropdown', []);

            this.setField('stadium', {
                options: stadiums.map((stadium) => ({
                    id: stadium.id,
                    key: stadium.id,
                    text: getSpiideoVenueLabel(stadium),
                    value: stadium.id,
                })),
                loading: false,
                disabled: false,
            });
        }).catch((error) => {
            this.setField('stadium', {
                loading: false,
                disabled: false,
            });
            this.setFormMessage(`${error.message}`);
        });
    };

    createLinkToIndexPage = () => (
        getLink('spiideoMappings.venues')
    );

    prepareDataForSubmit = (data) => {
        return (undefined === data)
            ? null
            : {
                id: data.id,
                stadium: data.stadium,
                spiideo_scene_uuid: data.spiideo_scene_uuid,
            };
    };

    renderErrors() {
        super.renderErrors(
            'The requested venue mapping could not be found',
            this.props.Model.entityLabel,
            this.createLinkToIndexPage()
        );
    }

    renderCancelButton = () => null;
}

SpiideoVenueMappingForm.displayName = 'SpiideoVenueMappingForm';

export default withRouter(SpiideoVenueMappingForm);
